module.exports = __webpack_public_path__ + "static/sitsLogo1-9fa4fb885c508a32f7933018e8e44a5c.png";